import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-fal-color-large.tsx
/**
* icon.24.logo.fal.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2VjMDY0OCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNjA3IDNjLjMxMSAwIC41NjEuMjUzLjU5LjU2NGE1LjgzIDUuODMgMCAwIDAgNS4yNCA1LjIzOGMuMzA5LjAzLjU2My4yOC41NjMuNTl2NS4yMTRjMCAuMzEyLS4yNTMuNTYxLS41NjQuNTkxYTUuODMgNS44MyAwIDAgMC01LjIzOCA1LjIzOGMtLjAzLjMxLS4yOC41NjQtLjU5MS41NjRIOS4zOTNjLS4zMTIgMC0uNTYyLS4yNTQtLjU5Mi0uNTY0YTUuODMgNS44MyAwIDAgMC01LjIzNy01LjIzOGMtLjMxLS4wMy0uNTY0LS4yOC0uNTY0LS41OVY5LjM5MmMwLS4zMTIuMjUzLS41NjEuNTY0LS41OTFBNS44MyA1LjgzIDAgMCAwIDguOCAzLjU2NGMuMDMtLjMxLjI4LS41NjQuNTkzLS41NjR6bS03Ljk5MyA4Ljk4NGE1LjQyIDUuNDIgMCAwIDAgNy40OSA1LjAxIDUuNDIgNS40MiAwIDAgMCAzLjM0NC01LjAxIDUuNDIgNS40MiAwIDAgMC01LjQxNy01LjQyMiA1LjQyIDUuNDIgMCAwIDAtNS40MTcgNS40MjIiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11158
*/
const Icon24LogoFalColorLarge = memo(function Icon24LogoFalColorLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "#ec0648",
			fillRule: "evenodd",
			d: "M14.607 3c.311 0 .561.253.59.564a5.83 5.83 0 0 0 5.24 5.238c.309.03.563.28.563.59v5.214c0 .312-.253.561-.564.591a5.83 5.83 0 0 0-5.238 5.238c-.03.31-.28.564-.591.564H9.393c-.312 0-.562-.254-.592-.564a5.83 5.83 0 0 0-5.237-5.238c-.31-.03-.564-.28-.564-.59V9.392c0-.312.253-.561.564-.591A5.83 5.83 0 0 0 8.8 3.564c.03-.31.28-.564.593-.564zm-7.993 8.984a5.42 5.42 0 0 0 7.49 5.01 5.42 5.42 0 0 0 3.344-5.01 5.42 5.42 0 0 0-5.417-5.422 5.42 5.42 0 0 0-5.417 5.422",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24LogoFalColorLarge };

//# sourceMappingURL=icon-24-logo-fal-color-large.js.map